"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageNumberProvider = exports.PageNumberContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useDebounce = require("use-debounce");
var _variables = require("../constants/variables");
var _useGetCatalogueStructure = require("../hooks/useGetCatalogueStructure");
var _getApiInstance = require("../utils/getApiInstance");
var _pageCounter = require("../utils/pageCounter");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const PageNumberContext = exports.PageNumberContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
PageNumberContext.displayName = 'PageNumberContext';
const PageNumberProvider = (param)=>{
    let { children, initialPageNumber } = param;
    const [initialPage, setInitialPage] = (0, _react.useState)(initialPageNumber !== null && initialPageNumber !== void 0 ? initialPageNumber : 1);
    const [currentPages, setCurrentPages] = (0, _react.useState)([
        initialPage
    ]);
    const [debouncedCurrentPages] = (0, _useDebounce.useDebounce)(currentPages, _variables.DEBOUNCE_DELAY);
    const [currentPagesInitialized, setCurrentPagesInitialized] = (0, _react.useState)(false);
    const { totalPageCount } = (0, _useGetCatalogueStructure.useGetCatalogueStructure)();
    const changePageNumber = (0, _react.useCallback)((input)=>{
        if (input === '') {
            return;
        }
        const page = (0, _pageCounter.transformPageInput)(input, totalPageCount);
        const ipaperApiInstance = (0, _getApiInstance.getApiInstance)();
        if (ipaperApiInstance) {
            ipaperApiInstance.paging.goToPage(page);
        }
    }, [
        totalPageCount
    ]);
    (0, _react.useLayoutEffect)(()=>{
        setInitialPage((0, _pageCounter.getPageNumberParamFromUrl)());
    }, []);
    (0, _react.useEffect)(()=>{
        if (totalPageCount !== 0) {
            const currentPage = (0, _pageCounter.transformPageInput)(initialPage, totalPageCount);
            setCurrentPages([
                currentPage
            ]);
        }
    }, [
        initialPage,
        totalPageCount
    ]);
    (0, _react.useEffect)(()=>{
        const currentPage = debouncedCurrentPages[0];
        if (currentPage != null) {
            (0, _pageCounter.updatePageNumberUrlParam)(currentPage);
        }
    }, [
        debouncedCurrentPages
    ]);
    const value = (0, _react.useMemo)(()=>({
            changePageNumber,
            currentPages,
            initialPage,
            totalPageCount,
            setCurrentPages,
            currentPagesInitialized,
            setCurrentPagesInitialized
        }), [
        changePageNumber,
        currentPages,
        initialPage,
        totalPageCount,
        currentPagesInitialized
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PageNumberContext.Provider, {
        value: value,
        children: children
    });
};
exports.PageNumberProvider = PageNumberProvider;
